<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Payment Detail
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="typep"
                :label="this.localForm.typep"
                :items="orderPaymentMethodOptions"
                color="wplblue0"
                prepend-icon="payments"
                hint="payment type"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="localForm.statp"
                :label="this.localForm.statp"
                :items="orderPaymentStatusOptions"
                color="wplblue0"
                prepend-icon="adjust"
                hint="payment status"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.payd"
              :rules="mustBeZeroOrMore"
              prepend-icon="local_atm"
              prefix="$"
              hint="deposit"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.paya"
              :rules="mustBeZeroOrMore"
              prefix="$"
              prepend-icon="price_change"
              hint="adjust"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.pay"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="payment requirements and additional comments"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Payment Summary
            </div>
            <v-spacer/>
            <div class="ml-4 mr-4 mt-4">
              AUD
            </div>
          </v-layout>
          <v-layout row class="ml-4 mt-3">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> shopping_bag </v-icon>
                <div :class="ui.textSubheadingBold">
                  Order
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <div :class="ui.textSubheadingBold">
                {{this.calcCost(this.getDetailChar.costo, "", this.getDetailChar.qty)}}
              </div>
            </v-chip>
          </v-layout>
          <v-layout row class="ml-4 mt-3">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> local_shipping </v-icon>
                <div :class="ui.textSubheadingBold">
                  Transport
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <div :class="ui.textSubheadingBold">
                {{this.calcCost(this.getDetailChar.costt, "", 1)}}
              </div>
            </v-chip>
          </v-layout>
          <v-layout row class="ml-4 mt-3">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> local_atm </v-icon>
                <div :class="ui.textSubheadingBold">
                  Deposit
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <div :class="ui.textSubheadingBold">
                {{this.calcCost(this.getDetailChar.payd, "()", 1)}}
              </div>
            </v-chip>
          </v-layout>
          <v-layout row class="ml-4 mt-3">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> price_change </v-icon>
                <div :class="ui.textSubheadingBold">
                  Adjust
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <div :class="ui.textSubheadingBold">
                {{this.calcCost(this.getDetailChar.paya, "", 1)}}
              </div>
            </v-chip>
          </v-layout>
          <v-layout row class="ml-4 mt-3">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> functions </v-icon>
                <div :class="ui.textSubheadingBold">
                  Remaining
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <div :class="ui.textSubheadingBold">
                {{this.calcRemainingCost(this.getDetailChar)}}
              </div>
            </v-chip>
          </v-layout>
          <v-layout row class="ml-4 mt-4">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> attach_money </v-icon>
                <div :class="ui.textSubheadingBold">
                  Total Cost
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <div :class="ui.textSubheadingBold">
                {{this.calcTotalOrderCost(this.getDetailChar)}}
              </div>
            </v-chip>
          </v-layout>
          <v-layout row class="ml-4">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> co2 </v-icon>
                <div :class="ui.textSubheadingBold">
                  Total Carbon
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <div :class="ui.textSubheadingBold">
                {{this.calcTotalOrderCarbon(this.getDetailChar)}}
              </div>
            </v-chip>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import orderOptions from "@/data/options/mixins/orderOptions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        statp: "",
        typep: "",
        payd: "",
        pay: "",
        paya: ""
      },
      orgForm: {
        statp: "",
        typep: "",
        payd: "",
        pay: "",
        paya: ""
      },
      typep: "",
      statp: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.typep = this.getDetail.char.typep;
    this.localForm.statp = this.getDetail.char.statp;
    this.localForm.pay = this.getDetail.char.pay;
    this.localForm.paya = this.getDetail.char.paya;
    this.localForm.payd = this.getDetail.char.payd;

    this.orgForm.typep = this.getDetail.char.typep;
    this.orgForm.statp = this.getDetail.char.statp;
    this.orgForm.pay = this.getDetail.char.pay;
    this.orgForm.paya = this.getDetail.char.paya;
    this.orgForm.payd = this.getDetail.char.payd;
  },
  watch: {
    statp() {
      this.localForm.statp = this.statp;
      this.updateFormChar();
    },
    typep() {
      this.localForm.typep = this.typep;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    orderOptions,
    techOptions,
    financeFunctions
  ],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar", "getCurrentPage"])
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.paya !== this.orgForm.paya &&
        this.localForm.paya !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.paya = this.localForm.paya;
        // basic
        char.paya = this.localForm.paya;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.tqut !== this.orgForm.tqut &&
        this.localForm.tqut !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.tqut = this.localForm.tqut;
        // basic
        char.tqut = this.localForm.tqut;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.typep !== this.orgForm.typep &&
        this.localForm.typep !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.typep = this.localForm.typep;
        // basic
        char.typep = this.localForm.typep;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.statp !== this.orgForm.statp &&
        this.localForm.statp !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.statp = this.localForm.statp;
        // basic
        char.statp = this.localForm.statp;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.payd !== this.orgForm.payd &&
        this.localForm.payd !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.payd = this.localForm.payd;
        // basic
        char.payd = this.localForm.payd;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.pay !== this.orgForm.pay &&
        this.localForm.pay !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.pay = this.localForm.pay;
        // basic
        char.pay = this.localForm.pay;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
